function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgServicos = function SvgServicos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33 7.175a2 2 0 01-1.623-2.317l.521-2.955A2 2 0 016.545.28L19.84 2.625a2 2 0 011.622 2.316l-.174.986.247.043a2 2 0 011.622 2.316l-.392 2.223a1.999 1.999 0 01-2.317 1.622l-7.387-1.302a.998.998 0 00-1.157.811l-.174.985.246.044a1.999 1.999 0 011.622 2.316l-1.173 6.654a2.001 2.001 0 01-2.317 1.623l-1.477-.26a2 2 0 01-1.622-2.318l1.173-6.654a2 2 0 012.317-1.622l.246.043.174-.984a1.998 1.998 0 012.316-1.622l7.387 1.302a.999.999 0 001.158-.811l.392-2.223a1 1 0 00-.811-1.158l-.246-.044-.174.985a2 2 0 01-2.317 1.622L5.329 7.175zm13.468 1.36a1 1 0 001.158-.812l.521-2.955a1 1 0 00-.81-1.158L6.371 1.266a1 1 0 00-1.16.81l-.52 2.956a1 1 0 00.811 1.158l13.295 2.344zm-7.357 12.93l1.172-6.654a1 1 0 00-.81-1.158l-1.478-.26a1 1 0 00-1.158.81l-1.173 6.655a1.001 1.001 0 00.81 1.159l1.478.26a1.001 1.001 0 001.159-.812z",
    fill: props.color
  }));
};

SvgServicos.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgServicos.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgServicos;